import { Component, inject, OnInit } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import {
  Contract,
  ContractsResponse,
} from 'src/app/services/contracts/contract.model';
import { ContractsService } from 'src/app/services/contracts/contracts.service';
import { UserService } from 'src/app/services/user.service';
import { UserDetails } from '../../login/user.model';
import { LotsService } from 'src/app/services/lots.service';
import { SeoService } from 'src/app/services/seo.service';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { LogEventsEnum } from 'src/app/firebase.model';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PriceTypePipe } from 'src/app/pipes/price-type.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@Component({
  selector: 'app-contracts',
  templateUrl: './contracts.component.html',
  styleUrls: ['./contracts.component.css'],
  imports: [
    CommonModule,
    RouterModule,
    PriceTypePipe,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    MatSnackBarModule,
    MatRippleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDividerModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressBarModule,
    MatBottomSheetModule,
    MatMenuModule,
    MatBadgeModule,
  ],
  standalone: true,
})
export class ContractsComponent implements OnInit {
  private analytics = inject(Analytics);
  isLoading: boolean;
  contracts$: Observable<Contract[]>;
  userDetails: UserDetails;
  constructor(
    private contractService: ContractsService,
    private userService: UserService,
    private lotsService: LotsService,
    private seoService: SeoService
  ) {}

  ngOnInit(): void {
    this.seoService.updateMetaTags([
      { name: 'description', content: 'List of My Contracts' },
      { name: 'author', content: "Johnston's Connected" },
      { name: 'keywords', content: 'My Contracts' },
    ]);
    this.seoService.updateTitle('Contracts Page');

    this.isLoading = true;
    this.userDetails = this.userService.getUserDetails();
    this.contracts$ = this.contractService
      .watch({ limit: 40 })
      .valueChanges.pipe(
        map((res) => {
          this.isLoading = false;
          logEvent(this.analytics, LogEventsEnum.contracts_list_view);
          // check if product type is return
          return res.data.contracts;
        })
      );
  }
}
